import React from "react";
import { Link } from "react-router-dom";
import { cn } from "../utils/style";

function IconButtonLink({ children, href, className, secondary }) {
  return (
    <Link
      to={href || "#"}
      className={cn(
        "group flex items-center justify-center p-2.5 rounded-xl transition-all duration-300 border shadow-sm active:scale-90",
        {
          "bg-white border-slate-200 text-slate-500 hover:border-primary-200 hover:text-primary-600 hover:bg-primary-50 hover:shadow-md hover:shadow-primary-500/5":
            !secondary,
          "bg-slate-50 border-slate-200 text-slate-400 hover:bg-white hover:text-slate-600":
            secondary,
        },
        className,
      )}
    >
      <div className="h-5 w-5 flex items-center justify-center transition-transform duration-300 group-hover:scale-110">
        {children}
      </div>
    </Link>
  );
}

export default IconButtonLink;
